import React, { Component } from 'react'

export default class AboutContainer extends Component {
    render() {
        return (
            <div>
                <h1>About</h1>
                <p>Stamp Collector App version 1.0.0</p>
            </div>
        )
    }
}
